import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Star } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useStudent } from "@/context/StudentContext";
import { PageHeader } from "@/components/PageHeader";

export default function Perkembangan() {
  const [params] = useSearchParams();
  const { activeId } = useStudent();
  const sid = params.get("student") || activeId;
  const [a, setA] = useState(null);

  useEffect(() => {
    if (sid) api.get(`/assessments?student_id=${sid}`).then((r) => setA(r.data[0] || null));
  }, [sid]);

  return (
    <div>
      <PageHeader title="Predikat Anak" />
      <div className="px-5 pt-4">
        {!a ? (
          <p className="text-center text-stone-400 mt-10">Belum ada penilaian.</p>
        ) : (
          <>
            <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
              className="bg-secondary/15 border border-secondary/30 rounded-3xl p-5 mb-5 flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl bg-secondary/30 flex items-center justify-center">
                <Star size={34} weight="fill" className="text-secondary" />
              </div>
              <div>
                <p className="text-xs text-stone-500 uppercase tracking-wide">Predikat</p>
                <p className="font-heading text-2xl font-bold text-stone-800">{a.predikat}</p>
                <p className="text-stone-500 text-xs">{a.period}</p>
              </div>
            </motion.div>

            <h3 className="font-heading font-semibold text-stone-800 mb-3">Aspek Perkembangan</h3>
            <div className="bg-white rounded-3xl border border-stone-200/60 shadow-sm divide-y divide-stone-100 overflow-hidden">
              {a.aspects.map((asp, i) => (
                <div key={i} data-testid={`aspect-${i}`} className="flex items-center justify-between px-4 py-3.5">
                  <span className="text-stone-700 text-sm">{asp.name}</span>
                  <div className="flex gap-0.5">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <Star key={n} size={18} weight="fill" className={n <= asp.stars ? "text-secondary" : "text-stone-200"} />
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {a.note && (
              <div className="mt-5">
                <h3 className="font-heading font-semibold text-stone-800 mb-2">Catatan Guru</h3>
                <div className="bg-white rounded-2xl border border-stone-200/60 p-4 shadow-sm">
                  <p className="text-stone-600 text-sm leading-relaxed">{a.note}</p>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
